import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';
import { BoxesApi } from '@/lib/api/item-store/boxes';
import { commonQueryKeys } from '@/lib/query-keys/common';
import { containsIgnoreCase } from '@/lib/utils/common/rsqlFilters';

const getSearchValueFilter = (searchValue: string) => {
  const trimmedSearch = searchValue.trim();
  return trimmedSearch ? containsIgnoreCase('name', trimmedSearch) : undefined;
};

export const boxesInfiniteQueryOptions = ({ filter }: { filter?: string } = {}) =>
  infiniteQueryOptions({
    queryKey: commonQueryKeys.boxes.all({ filter }),
    queryFn: ({ pageParam }) => BoxesApi.getBoxes({ cursor: pageParam, filter }),
    initialPageParam: '',
    getNextPageParam: (lastPage) => lastPage.cursor,
    select: (paginatedData) => paginatedData.pages.flatMap((page) => page.data),
  });

export const useBoxesInfiniteQuery = ({ searchValue }: { searchValue?: string } = {}) => {
  const filter = getSearchValueFilter(searchValue ?? '');

  return useInfiniteQuery(boxesInfiniteQueryOptions({ filter }));
};
